import { useEffect, useRef, useState } from 'react'
import { useAuth } from '@praxis/component-auth'
import AppLayout from '../../components/Layout/AppLayout'
import { BrandProvider } from '../../brand/context/BrandContext'
import { userService } from '../../brand/services/userService'
import { clearUserSession, saveUserSession } from '../helpers/sessionStorage'

const AppAuthentication = () => {
  const loginStarted = useRef(false)
  const [persistedSession, setPersistedSession] = useState(null)
  const { isAuthenticated, login, logout, session } = useAuth()
  const isUserAuthenticated = isAuthenticated()

  useEffect(() => {
    if (!isUserAuthenticated) {
      clearUserSession()
      setPersistedSession(null)
      if (!loginStarted.current) {
        loginStarted.current = true
        login({ redirect: window.location.href })
      }
      return
    }

    loginStarted.current = false
    if (session) {
      setPersistedSession(saveUserSession(session))
      userService.registerUser().catch(() => {})
    }
  }, [isUserAuthenticated, login, session])

  return isUserAuthenticated && persistedSession ? (
    <BrandProvider>
      <AppLayout logout={logout} />
    </BrandProvider>
  ) : null
}

export default AppAuthentication
